/* eslint-disable no-unused-vars */
import React from 'react';
import { User } from 'store/types';
import style from './userData.module.scss';
import Skeleton from '@mui/material/Skeleton';
import { useAppSelector } from 'store/hooks';
import { selectPageIsLoading } from 'store/page/pageSlice';

export default function RequestItem({ user }: { user?: User }) {
  const pageIsLoading = useAppSelector(selectPageIsLoading);

  return (
    <div className={style.container}>
      {user && !pageIsLoading ? (
        <>
          <span
            className={style.name}
            title={`${user.name} ${user.surname}`}
          >{`${user.name} ${user.surname}`}</span>
          <span className={style.other} title={user.organization}>
            {user.organization}
          </span>
          <span className={style.other}>{user.email}</span>
        </>
      ) : (
        <>
          <Skeleton
            className={style.name}
            variant="text"
            width={150}
            height={22}
          />
          <Skeleton
            className={style.other}
            variant="text"
            width={150}
            height={17}
          />
          <Skeleton
            className={style.other}
            variant="text"
            width={150}
            height={17}
          />
        </>
      )}
    </div>
  );
}
